import { getGatewayLanguageParams } from './invitationLink';

const LEGACY_LANGUAGE_COOKIE_MAP = {
    en: 'english-united-states',
    es: 'spanish-international',
};

export const getGatewayLanguagePreference = (languages = []) => {
    const { gatewayLanguage, gatewayIntl } = getGatewayLanguageParams();
    const preferredCode = gatewayLanguage || LEGACY_LANGUAGE_COOKIE_MAP[gatewayIntl];

    if (!preferredCode) return null;

    return (
        languages.find((language) => language.value === preferredCode || language.code === preferredCode) ||
        null
    );
};
